import { getAppStoreCurrentState } from "../../store";
import { actions } from "./slice";
import { AppMessage } from "./utils/message";

export const handleError = (message) => (dispatch) => {
  const messages = getAppStoreCurrentState().appMessages;

  if (!messages.includes((el) => el.message === message)) {
    return dispatch(actions.set({ message: new AppMessage({ type: "error", message }).get() }));
  }
};

export const showSuccess = (message) => {
  return actions.set({ message: new AppMessage({ type: "success", message }).get() });
};
